import DeleteModal from "components/molecules/delete-modal/DeleteModal"
import withModal from "lib/helpers/hoc/withModal"
import { useDeleteProducts } from "lib/hooks/mutations/Customers/useDeleteProduct"
import { FC } from "react"


interface Props {
    setDeleteData: ({ id, name }: { id: string; name: string }) => void
    DeleteData: { id: string, name: string }
}

const DeleteProductModal: FC<Props> = ({ setDeleteData, DeleteData }) => {

    const { isLoading: isLoadingDeleteProduct, mutateAsync: DeleteProduct } = useDeleteProducts()

    return (
        <DeleteModal
            onConfirm={() => { setDeleteData({ id: '', name: '' }) }}
            data={DeleteData}
            deleteFunction={DeleteProduct}
            isLoading={isLoadingDeleteProduct}
        />
    )
}

export default withModal(DeleteProductModal)